import { Controller } from "stimulus"
import Highcharts from 'highcharts'

export default class extends Controller {
  static targets = ['chart', 'chartData']

  connect() {
    this.chartData = JSON.parse(this.chartDataTarget.textContent)
    this.initChart()
  }

  initChart() {
    const chart = new Highcharts.chart(this.chartTarget, this.chartOptions())

    const opticalDensities = this.chartData.opticalDensities.map(el => [Date.parse(el.recordedAt), el.value])
    chart.series[0].setData(opticalDensities)

    this.chartData.sowings.forEach(sowing => {
      chart.xAxis[0].addPlotLine({
        value: Date.parse(sowing.sowedAt),
        color: '#0B3954',
        width: 1
      })
    })
  }

  chartOptions() {
    return {
      title: {
        text: null
      },
      credits: false,
      legend: {
        enabled: false
      },
      yAxis: {
        title: {
          text: null
        },
        labels: {
          enabled: false
        },
        min: 0,
        tickInterval: 0.1,
        lineWidth: 0,
        gridLineWidth:0,
        minorGridLineWidth: 0,
        lineColor: 'transparent',
      },
      xAxis: {
        labels: {
          enabled: false
        },
        tickLength: 0
      },
      series: [
        {
          name: 'Optical density',
          type: 'area',
          enableMouseTracking: false,
          color: '#90ed7d'
        }
      ]
    }
  }
}
